import {
    Directive,
    Input,
    OnInit,
    HostListener,
    OnDestroy,
    HostBinding,
} from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { MediaObserver } from "@ngbracket/ngx-layout";
import { WtfMatSidenavHelperService } from "./mat-sidenav-helper.service";

import { WtfMatchMedia } from "../../../../services/core/match-media.service";

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Directive({
    selector: "[wtfMatSidenavHelper]",
})
export class WtfMatSidenavHelperDirective implements OnInit, OnDestroy {
    @HostBinding("class.mat-is-locked-open") isLockedOpen: boolean;
    @HostBinding("class.mat-stop-transition") stopTransition = true;

    @Input("wtfMatSidenavHelper") id: string;
    @Input("mat-is-locked-open") matIsLockedOpenBreakpoint: string;

    private _unsubscribeAll: Subject<any>;

    constructor(
        private wtfMatSidenavService: WtfMatSidenavHelperService,
        private wtfMatchMedia: WtfMatchMedia,
        private _observableMedia: MediaObserver,
        private matSidenav: MatSidenav
    ) {
        this.isLockedOpen = true;
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.wtfMatSidenavService.setSidenav(this.id, this.matSidenav);

        if (this._observableMedia.isActive(this.matIsLockedOpenBreakpoint)) {
            this.isLockedOpen = true;
            this.matSidenav.mode = "side";
            this.matSidenav.toggle(true);
        } else {
            this.isLockedOpen = false;
            this.matSidenav.mode = "over";
            this.matSidenav.toggle(false);
        }

        this.wtfMatchMedia.onMediaChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                if (
                    this._observableMedia.isActive(
                        this.matIsLockedOpenBreakpoint
                    )
                ) {
                    setTimeout(() => {
                        this.isLockedOpen = true;
                        this.matSidenav.mode = "side";
                        this.matSidenav.open();
                    });
                } else {
                    setTimeout(() => {
                        this.isLockedOpen = false;
                        this.matSidenav.mode = "over";
                        this.matSidenav.close();
                    });
                }
            });
    }

    ngOnDestroy() {
        this._unsubscribeAll.unsubscribe();
        this._unsubscribeAll.complete();
    }
}

@Directive({
    selector: "[wtfMatSidenavToggler]",
})
export class WtfMatSidenavTogglerDirective {
    @Input("wtfMatSidenavToggler") id;

    constructor(private wtfMatSidenavService: WtfMatSidenavHelperService) {}

    @HostListener("click")
    onClick() {
        this.wtfMatSidenavService.getSidenav(this.id).toggle();
    }
}
